import current from "./private-send-pin.json";
import legacy from "./legacy-private-send-pin.json";
export interface PoolPin {
  networkPassphrase: string;
  contractId: string;
  operatorAddress: string;
  wasmSha256: string;
  nativeXlmSac: string;
  deployHash: string;
  initializeHash: string;
  proverSha256: string;
  parametersSha256: string;
  api: string;
  privateFeeCapStroops: string;
  capacity: number;
  proverPath?: string;
  browserParametersPath?: string;
  browserParametersSha256?: string;
  depositAdapterId?: string;
  depositAdapterWasmSha256?: string;
}
export const poolProfiles: PoolPin[] = [
  current,
  ...(current.contractId === legacy.contractId ? [] : [legacy]),
];
export function poolProfile(contractId: string) {
  const pin = poolProfiles.find((p) => p.contractId === contractId);
  if (!pin) throw Error("Unknown Testnet pool configuration");
  return pin;
}
